"use client";

import { useEffect, useRef, useState } from "react";
import { usePathname } from "next/navigation";
import { useRegionStore, useLocationStore } from "@/store/index";
import { validateLocation } from "@/lib/data/locations";


export function LocationValidator() {
  const pathname = usePathname();
  const { countryCode, setIsMaintenanceMode } = useRegionStore();
  const { province, municipality, hasSelectedLocation } = useLocationStore();

  const isChecking = useRef(false);
  const [isRehydrated, setIsRehydrated] = useState(false);

  // Wait for Zustand persist rehydration before validating
  useEffect(() => {
    const unsubRegion = useRegionStore.persist.onFinishHydration(() => {
      setIsRehydrated(true);
    });
    const unsubLocation = useLocationStore.persist.onFinishHydration(() => {
      setIsRehydrated(true);
    });

    if (
      useRegionStore.persist.hasHydrated() &&
      useLocationStore.persist.hasHydrated()
    ) {
      setIsRehydrated(true);
    }

    return () => {
      unsubRegion();
      unsubLocation();
    };
  }, []);

  useEffect(() => {
    if (!isRehydrated) return;
    if (!countryCode || !hasSelectedLocation || isChecking.current) return;

    const check = async () => {
      isChecking.current = true;

      const result = await validateLocation(
        countryCode,
        province || undefined,
        municipality || undefined
      );

      if (!result) {
        isChecking.current = false;
        return;
      }

      if (!result.has_any_active) {
        setIsMaintenanceMode(true);
        isChecking.current = false;
        return;
      }

      setIsMaintenanceMode(false);
      // Note: we no longer clear the store or force the modal when the
      // location becomes invalid. The product list will simply be empty
      // and the checkout completion route will block the order.

      isChecking.current = false;
    };

    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, countryCode, province, municipality, hasSelectedLocation, isRehydrated]);

  return null;
}
